<ng-container *ngIf="product$ | async as product">
  <div class="description-box"
        *ngIf="!!(product?.description)">
    <p class="description-title">{{ 'eProductDetails.description.label' | cxTranslate }}</p>
    <div [innerHTML]="product.description | cxSupplementHashAnchors">
    </div>
  </div>
</ng-container>
